module.exports = __webpack_public_path__ + "img/tick.78b7ddc8.png";